import logUtil from 'utils/log'

export default function scrollLeftDomUtil (props) {
  const { element, left } = props
  logUtil('scrollLeftDomUtil').debug('[start] props=', props)
  element.scrollLeft = left
}
